<template lang="html">
  <div id="results-page">

    <section class="breadcrumb-section">
      <div class="container oversized-container">
        <router-link to="/">Home</router-link>
        <span class="line">/</span>
        <span>Marca</span>
        <span class="line">/</span>
        <span>{{ brand.name }}</span>
      </div>
    </section>

    <section class="container oversized-container products-section">
      <div class="row mb-3">
        <div class="col-12 col-s-title">
          <h2 class="title">{{ brand.name }}</h2>
        </div>
      </div>

      <div class="row" v-if="isLoading">
        <div class="col-12">
          <loading-component></loading-component>
        </div>
      </div>

      <div class="row" v-else>
        <!-- Results -->
        <div class="col-12">
          <div class="row sample-products-wrapper xxl-5e">
            <div class="col-sm-6 col-md-4 col-lg-3 sample-product" v-for="(product, index) in products" :key="index">
              <div class="outlined-box">
                <router-link class="box-image" :to="'/producto/'+$root._converToURL(product.name, product.id)">
                  <div class="out-of-stock" v-if="product.stock < 1">Agotado</div>

                  <div class="placed-backg img" v-bind:style="{ backgroundImage: 'url('+product.img+')' }">
                    <img src="public/images/shared/empty.png" >
                  </div>
                </router-link>

                <div class="box-shot-descr">
                  <h6 class="brand">{{ product.sku }}</h6>
                  <h6 class="name">{{ product.name }}</h6>
                  <h6 class="price discount" v-if="product.oferta == 1"><span>{{ product.price_org }}</span></h6> 
                  <h6 class="price">{{ product.price }}</h6>
                  <h6 class="brand" style="font-size: 15px;color: #1b5985;">Existencias ({{ product.stock }})</h6>
                </div>
                <p class="p-button">
                  <router-link class="btn-more" :to="'/producto/'+$root._converToURL(product.name, product.id)">Ver más</router-link>
                </p>

                <cart-express-component :obj="{ id: product.id, name: product.name }"></cart-express-component>
              </div>
            </div>

            <h5 v-if="!products.length">No se encontraron resultados</h5>
          </div>
         
        </div>
        <!--  -->

      </div>
    </section>
  </div>
</template>

<script>
import LoadingComponent from '../shared/loading-component.vue';
export default {
  components: {
    LoadingComponent
  },

  data(){
    return{
      isLoading: true,
      products: [],

      filters: {
        keywords: '',
      },

      brand: [],
      brand_id:null,
    }
  },

  watch: {
    "$route.params.id" : function(v){
      this.brand_id = this.$root._getURLID(this.$route.params.id);
      if(this.brand_id){
          this.products = [];
          this.getProducts(this.brand_id);
      }
    },
  },

  methods: {

    getProducts: function(brand_id){
      this.isLoading = true;
      axios.get(tools.url('/api/products/brand/'+brand_id)).then((response) =>{
          this.products = response.data.products;
          this.brand = response.data.brand;
          this.isLoading = false;
      }).catch((error)=>{
        console.log(error);
        this.isLoading = false;
      });
    }
  },

  mounted(){
    if(this.$route.params.id){
      this.brand_id = this.$root._getURLID(this.$route.params.id);
      this.getProducts(this.brand_id);
    }
  },
}
</script>
